import React from "react";
import { Route, Redirect } from "react-router-dom";

import Login from "./Login";
const SignUp = () => <p>Sign up</p>;
/* const NoMatch = () => <p>NoMatch</p>; */

const AuthLayout = () => {
  return (
    <div>
      <Route path="/auth/login" component={Login} />
      <Route path="/auth/signup" component={SignUp} />
     {/*  <Route path="*">
        <NoMatch />
      </Route> */}
      <Redirect from="/auth" to="/auth/login" exact />
    </div>
  );
};

export default AuthLayout;
